module.exports = "/_next/static/images/expert-lori-bruun-62699c9cb9465f81badafeffc3e16b84.png";